// Попап упрощенной регистрации, выводится при попытке купить тарифный план анонимным пользователем.
// Принимает в качестве props данные о выбранном тарифном плане, создает платеж и
// после успешной регистрации переводит пользователя на оплату тарифного плана

import basePopup from "./base-popup";
import Analytics from "../../marketing/analytics";
import captcha from "../../captcha";
import payments from "../../payments/payments";

const template = /* html */`
    <transition name="fade">
        <base-popup
            id="signup-payment-popup"
            show-logo
            show-terms
            v-cloak
            :isActive="isActive"
            v-show="isActive"
        >
            <template #header>
                <div class="popup__header-text">
                    Зарегистрируем вас после оплаты
                </div>
            </template>
            <form method="POST" autocomplete="off" @submit.prevent="handleSubmit">
                <div class="form-group">
                    <label class="form-label" for="plan_email">Почта</label>
                    <input
                        data-ref="plan-email-input"
                        ref="email_input"
                        id="plan_email"
                        data-first type="email"
                        name="login-email"
                        data-suggest="email"
                        :data-focused="true"
                        :value="email"
                        @change="$emit('emailChanged', $event.target.value); clearError()"
                    />
                    <div
                        class="fotm-helptext"
                        data-help-text="для личного кабинета и важных сообщений"
                    >
                        для личного кабинета и
                        важных сообщений
                    </div>
                    <div v-if="error" data-ref="plan-payment-error" class="form-errors">
                        [[error]].
                        <a
                            v-if="errorType === 'registered'"
                            href="#"
                            data-ref="already-registered"
                            @click.prevent="$emit('openSigninPopup');"
                        >
                            Войти
                        </a>
                    </div>
                    <div
                        v-if="captchaKey"
                        id="signup-payment-popup-captcha"
                        class="js-captcha"
                        :data-sitekey="captchaKey"
                        :style="{minHeight: isCaptchaVisible ? '105px' : '0'}"
                    >
                    </div>
                </div>
                <div class="form-button-wrapper">
                    <input
                        type="submit"
                        value="Купить"
                        data-ref="plan-payment-submit"
                        class="button popup__button"
                        :disabled="submitting"
                    >
                </div>
            </form>
        </base-popup>
    </transition>
`;

export default {
    props: {
        captchaKey: { type: String },
        csrfToken: {
            type: String,
            required: true,
        },
        email: { type: String },
        isActive: { type: Boolean },
        amount: { type: Number },
        planName: { type: String },
        quantity: { type: Number },
    },
    data() {
        return {
            error: "",
            errorType: "",
            submitting: false,
            captchaId: null,
            isCaptchaVisible: false,
        };
    },
    template,
    watch: {
        isActive(newVal) {
            if (!newVal && !this.error) return;
            if (!newVal) {
                this.clearError();
            } else {
                this.isCaptchaVisible = false;
                Analytics.saveSignupPoint();

                this.captchaId = captcha.init("#signup-payment-popup-captcha", true);
                setTimeout(() => captcha.execute(this.captchaId), 1000);
            }
        },
    },
    methods: {
        clearError() {
            this.error = "";
            this.errorType = "";
        },
        reinitCaptcha() {
            this.captchaId = captcha.reinit(
                this.captchaId,
                "#signup-payment-popup-captcha",
            );
            this.isCaptchaVisible = true;
        },
        handleSubmit(e) {
            this.clearError();
            if (!this.email) {
                this.error = "Пожалуйста, укажите адрес эл. почты";
                return;
            }
            this.submitting = true;
            const token = e.target["smart-token"]?.value;
            payments.create(this.email, this.amount, this.planName, this.quantity, token)
                .then(resp => {
                    if (resp.errors) {
                        this.submitting = false;
                        this.error = resp.errors.global;
                        if (this.error === "Этот адрес эл. почты занят") {
                            this.errorType = "registered";
                        }
                        if (this.error === "Пройдите проверку на человека") {
                            this.reinitCaptcha();
                        }
                        return;
                    }
                    if (resp.data.signup) {
                        Analytics.reachGoal(
                            "SIGNUP_FINISH",
                            { SIGNUP_URL: document.location.href },
                        );
                        Analytics.reachGoal("LOGGED_IN");
                    }
                    window.location.assign(resp.data.redirect_url);
                })
                .catch(() => {
                    this.submitting = false;
                    this.error = "Что-то пошло не так";
                });
        },
    },
    components: { basePopup },
    emits: ["emailChanged", "openSigninPopup"],
    name: "SigninPaymentPopup",
};
